/**
 * GET /v1/intelligence/trust-scores — mirrors apps/api/src/routes/intelligence-engine.ts.
 * The response key is `trust_scores`; the Trust Alerts widget read `scores` and
 * so always reported every relationship healthy.
 */
import { api } from '@/lib/api';

export type TrustTrend = 'rising' | 'stable' | 'declining' | 'critical';

export interface TrustScoreRow {
  contact_email: string;
  contact_name: string | null;
  trust_score: number;
  trend: TrustTrend;
  revenue_at_risk_cents: number | null;
  recommended_action: string | null;
  recommended_channel: string | null;
  scored_at?: string | null;
}

export interface TrustScoresResponse {
  trust_scores: TrustScoreRow[];
  total: number;
  refreshed: boolean;
}

/**
 * Lowest 50 scores, every trend. Fetching unfiltered is what lets the widget tell
 * "no rows scored yet" from "rows scored, none declining" — a trend-filtered
 * request returns [] for both.
 */
export function getTrustScores(): Promise<TrustScoresResponse> {
  return api<TrustScoresResponse>('/v1/intelligence/trust-scores?limit=50');
}

/** Declining and critical contacts, lowest score first. */
export function trustAlertRows(data: TrustScoresResponse, limit = 5): TrustScoreRow[] {
  return data.trust_scores
    .filter(s => s.trend === 'declining' || s.trend === 'critical')
    .sort((a, b) => a.trust_score - b.trust_score)
    .slice(0, limit);
}
